module.exports = __webpack_public_path__ + "img/15_dana_n.b83502ce.png";